module.exports = __webpack_public_path__ + "static/SG-909c5c0d17aea27a6bc72a91f662c589.jpg";